import React from 'react';
import PropTypes from 'prop-types';
import CustomRadio from '../common/CustomRadio';
import CustomSelect from '../common/CustomSelect';
//import CustomInput from './common/CustomInput'; // Revert to CustomInput
import NewCustomInputText from '../common/NewCustomInputText';

const Div4 = ({ formData, setFormData, errors, setErrors, handleChange, handleFontSizeChange }) => {
  const fontSizeOptions = ['6pt', '7pt', '8pt', '9pt', '10pt', '11pt', '12pt', '14pt', '16pt'];
  const defaultFontSize = '8pt';

  return (
    <div className="mb-6 border-b border-gray-300 pb-4">
      <h3 className="text-xl font-semibold mb-0 text-gray-900">
        Description <span className="text-red-700">*</span>
      </h3>

      <div className="flex items-center gap-6 mb-2">
        <div className="flex items-center gap-2">
          <div className="flex">
            <span className="text-gray-900 font-bold mr-5">Background:</span>
            <CustomRadio
              id="contentbg"
              name="contentbg"
              options={['Normal', 'Dark']}
              value={formData.contentbg}
              onChange={handleChange}
              error={errors.contentbg}
              required
            />
          </div>
        </div>
        <div className='w-24'>
          <CustomSelect
            id="contentfs"
            label={<span>Text Size</span>}
            name="contentfs"
            options={fontSizeOptions}
            value={formData.contentfs}
            onChange={(e) => handleFontSizeChange('content')(e)}
            error={errors.contentfs}
          />
        </div>
      </div>

      <NewCustomInputText
        id="content"
        label="Enter description"
        name="content"
        type="textarea"
        value={formData.content}
        language={formData.language}
        onChange={handleChange}
        placeholder="Enter description"
        error={errors.content}
        required
        // labelClassName={`w-full border border-gray-300 rounded-md py-2 px-3 ${formData.contentbg === 'Dark' ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600'}`}
        style={{ fontSize: formData.contentfs || defaultFontSize }}
      />
    </div>
  );
};

Div4.propTypes = {
  formData: PropTypes.shape({
    contentbg: PropTypes.string,
    contentfs: PropTypes.string,
    content: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  setErrors: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFontSizeChange: PropTypes.func.isRequired,
};

export default Div4;